import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(4)};
    height: ${spacing(4)};
  `}
`;

type Props = {
  color: string;
  className?: string;
};

const ArrowDownLeft = ({ className = '', color }: Props) => (
  <Svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path d="M17 7L7 17M7 17H17M7 17V7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default ArrowDownLeft;
